import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printProduct } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.PRODUCT,
  api: printProduct,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintProductAction.js